export function formatNumber(number: number): string {
	return new Intl.NumberFormat("nl-BE").format(+number.toFixed(2));
}
